module.exports = __webpack_public_path__ + "img/project-1.6aabe0cb.jpg";